import { useState, useRef } from "react";
import { F, D } from "../../../styles/palette";
import { DC, Bdg } from "../../shared";
import usePatients from "../../../hooks/usePatients";
import PatientForm from "./PatientForm";
import PatientDetail from "./PatientDetail";
import { ISL } from "../../../data/islStages";

export default function DPacientes({ user }) {
  const [view, setView] = useState("list");
  const [selected, setSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const debounce = useRef(null);
  const { patients, loading, error, hasMore, searchPatients, addPatient, updatePatient, getPatient, loadMore } = usePatients(user?.uid);

  const handleSearch = (val) => {
    setSearchTerm(val);
    clearTimeout(debounce.current);
    debounce.current = setTimeout(() => searchPatients(val), 400);
  };

  const handleSelectPatient = (p) => {
    setSelected(p);
    setView("detail");
  };

  const handleSaved = () => {
    setView("list");
    searchPatients("");
  };

  if (view === "new") {
    return <PatientForm user={user} addPatient={addPatient} onCancel={() => setView("list")} onSaved={handleSaved} />;
  }

  if (view === "detail" && selected) {
    return <PatientDetail
      patient={selected}
      user={user}
      updatePatient={updatePatient}
      getPatient={getPatient}
      addPatient={addPatient}
      onBack={() => { setView("list"); setSelected(null); }}
    />;
  }

  return (
    <div>
      <div style={{ display: "flex", gap: 10, marginBottom: 16, alignItems: "center" }}>
        <div style={{ flex: 1, position: "relative" }}>
          <input
            type="text"
            value={searchTerm}
            onChange={e => handleSearch(e.target.value)}
            placeholder="Buscar por apellido o n\u00famero de documento..."
            style={{ width: "100%", padding: "10px 14px 10px 36px", borderRadius: 8, border: `1px solid ${D.bdr}`, background: "rgba(30,41,59,0.8)", color: "#e2e8f0", fontSize: 13, fontFamily: F.b, boxSizing: "border-box" }}
          />
          <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", fontSize: 15, opacity: 0.4 }}>&#128269;</span>
        </div>
        <button
          onClick={() => setView("new")}
          style={{ padding: "10px 18px", borderRadius: 8, border: "none", background: D.ac, color: "#020617", fontSize: 13, fontWeight: 700, cursor: "pointer", fontFamily: F.b, whiteSpace: "nowrap" }}
        >+ Nuevo Paciente</button>
      </div>

      {error && <p style={{ color: "#f87171", fontSize: 13 }}>{error}</p>}

      {loading && patients.length === 0 && (
        <p style={{ color: D.txM, fontSize: 13, textAlign: "center", padding: 30 }}>Cargando pacientes...</p>
      )}

      {!loading && patients.length === 0 && (
        <DC>
          <p style={{ color: D.txM, fontSize: 13, textAlign: "center", padding: 20 }}>
            {searchTerm ? "No se encontraron pacientes" : "A\u00fan no hay pacientes registrados. Haga clic en \"Nuevo Paciente\" para comenzar."}
          </p>
        </DC>
      )}

      {patients.map(p => {
        const islData = p.estadioISL != null ? ISL[p.estadioISL] : null;
        return (
          <div
            key={p.id}
            onClick={() => handleSelectPatient(p)}
            style={{ background: D.card, border: `1px solid ${D.bdr}`, borderRadius: 12, padding: "14px 18px", marginBottom: 8, cursor: "pointer", backdropFilter: "blur(12px)", transition: "border-color 0.2s" }}
            onMouseEnter={e => e.currentTarget.style.borderColor = "rgba(45,212,191,0.4)"}
            onMouseLeave={e => e.currentTarget.style.borderColor = D.bdr}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 700, color: "#e0f2fe", fontFamily: F.b }}>
                  {p.primerApellido} {p.segundoApellido || ""}, {p.primerNombre} {p.segundoNombre || ""}
                </div>
                <div style={{ fontSize: 12, color: D.txM, marginTop: 3 }}>
                  {p.tipoDocumento}: {p.numeroDocumento} &nbsp;|&nbsp; {p.eps || "Sin EPS"}
                </div>
              </div>
              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                {p.miembroAfectado && <Bdg t={p.miembroAfectado} c="#0284c7" />}
                {islData && <Bdg t={islData.s} c={islData.c} />}
              </div>
            </div>
          </div>
        );
      })}

      {hasMore && (
        <div style={{ textAlign: "center", marginTop: 12 }}>
          <button
            onClick={loadMore}
            disabled={loading}
            style={{ padding: "8px 24px", borderRadius: 8, border: `1px solid ${D.bdr}`, background: "transparent", color: D.ac, fontSize: 12, fontWeight: 600, cursor: "pointer", fontFamily: F.b }}
          >{loading ? "Cargando..." : "Cargar m\u00e1s"}</button>
        </div>
      )}
    </div>
  );
}
